import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/letter/task",
        component: List,
        name: "letter.task",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/task/create",
        component: Create,
        name: "letter.task.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/task/:id/view",
        component: Edit,
        name: "letter.task.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/task/:id/edit",
        component: Edit,
        name: "letter.task.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
